<script>
  import Vue from 'vue';
  import config from '../../libs/config.json';
  import func from '../../libs/functions.js';
  import { EventBus } from '../../libs/event-bus.js';
  import moment from 'moment';
  import Axios from 'axios'
  import api from '../../api'
    import _system from '../../libs/system';
  import { mapGetters, mapActions } from 'vuex'
  
    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';

      import { Datetime } from 'vue-datetime';
  Vue.component('datetime', Datetime);
  import 'vue-datetime/dist/vue-datetime.css'
	
	export default 
	{
    name: 'StatisticsFilter',
		data() 
        {
        	return {
            func, func,
            filter: {
              accounts : null
            },
            startDate: '',
            endDate: '',
            currentDate: '',
            filterv2: {
              accounts : null,
              status: null,
              assignedTo: false,
              tags: [],
              pageIds: []
            },
            statistics: {
              total: 0,
              pending: 0,
              solved: 0,
              timing: 0
            },
              active: 0,
              active2: 0,
              hovered: '99999'
        	}
        },
        computed: {
	        ...mapGetters('session', ['isLoggedIn', 'getUser']),
          ...mapGetters('statuses', ['statuses']),
          ...mapGetters('loading', ['loadingStatistics']),
          ...mapGetters('tags', ['tagsByName']),
	        ...mapGetters('networks', ['networks', 'networksById']),
          ...mapGetters('accounts', ['accounts', 'activeAccounts']),
          ...mapGetters('workspaces', ['currentWorkspace']),
          ...mapGetters('mobileMenu', ['rightMobileMenu']),
          ...mapGetters('statistics', ['getStatistics']),
          ...mapGetters('inboxFilters', ['getInboxFilters', 'getInboxFilterLastUpdatedTime']),
          onlyActiveAccounts(){
            let onlyActivePages = _.filter(this.accounts, (account) => {
              if(account.tags && account.tags.indexOf(this.tagsByName['Passive']._id) == -1 || !account.tags) return account;
            });
            return onlyActivePages
          }
      },
      methods: {
        ...mapActions('loading', ['setLoadingStatistics']),
        ...mapActions('messages', ['setMessages']),
        ...mapActions('accounts', ['setAccounts']),
        ...mapActions('mobileMenu', ['toggleRightMenu']),
        ...mapActions('statistics', ['setStatistics']),
        ...mapActions('inboxFilters', ['setInboxFilters', 'setInboxFiltersPageIds', 'setInboxFiltersIsMention', 'setInboxFiltersTags', 'setInboxFiltersNotTags', 'setInboxFiltersStatusId','setInboxFiltersSkip', 'setInboxFiltersType', 'setInboxFiltersAfter', 'setInboxFiltersBefore', 'setInboxFiltersAssignedToMe', 'setInboxFilterLastUpdatedTime', 'setSaveFilters']),
                orderByName(accounts){
          return _.orderBy(accounts, ['name']);
        },
      updateTime(){
        setTimeout( () => {
            this.setInboxFiltersAfter(new Date(this.startDate).getTime())
            this.setInboxFiltersBefore(new Date(this.endDate).getTime())
            this.setInboxFilterLastUpdatedTime(+ new Date())
            //this.fecthStatistics();
        }, 500)
      },
        fecthStatistics(){
          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            }
          }

          if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after

          if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before

          if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds

          _system.services.statistics.get(payload, (err, data) => {
            if(err) return alert('New reports are getting ready. Could you please visit again in 30 seconds? (v2)');

            this.setStatistics(data);
          });
          
        },
        updateDate(day){
          this.setInboxFiltersAfter(moment(new Date()).subtract(day, 'day').valueOf());
        },
        isActive(_id, type){
            if(type == 'Channels'){
              if(_.find(this.getInboxFilters.pageIds, (id) => id == _id)) {
                return true
              }else{
                return false
              }
            }

            if(type == 'Dates'){
              console.log()
              if(parseInt( (+ new Date() - this.getInboxFilters.after) / (24*60*60*1000)) == _id) {
                return true
              }else{
                return false
              }
            }

          },
        checkActive(item, array){
          if(array.indexOf(item._id) > -1){
            return true
          }else{
            return false
          }
        },
    updateAccounts(account){

          this.setInboxFiltersType('page')

          var index = this.getInboxFilters.pageIds.indexOf(account._id);

          if(index > -1) {
              this.getInboxFilters.pageIds.splice(index, 1);
          }else{
              this.getInboxFilters.pageIds.push(account._id);
          }

          this.setInboxFiltersPageIds(this.getInboxFilters.pageIds);
          this.setInboxFilterLastUpdatedTime(+ new Date())
        },
        checkNetwork(_id){
          return  _.find(this.networks, function(e){ return e._id == _id }).name
        }
      },
        created()
        {
         
        //this.updateDate(7);

      let currentSec = + new Date();

      let currentSecMinus30Days = currentSec - 2592000000;
      let currentSecMinus7Days = currentSec - 2592000000/3;
      let currentSecMinus10Days = currentSec - 2592000000/3;

            //Set high volume customers here
      if(this.getUser.email.includes('jeenasikho.co.in')) {
         currentSecMinus10Days = currentSec - 1000*60*60*24*5;
      }

      this.startDate = new Date( currentSecMinus10Days ).toISOString()
      this.endDate = new Date( currentSec + 86400000 ).toISOString()

      this.currentDate = new Date( currentSec + 86400000 ).toISOString()

      //this.updateTime();

      //console.log(moment(new Date()).subtract(7, 'day').valueOf()/1000)

    //this.setInboxFiltersAfter(moment(new Date()).subtract(day, 'day').valueOf());

        }
	}
</script>

<template>   
<div style="background: #f5f5f5; padding: 25px 20px;" v-bind:style="{ padding: (rightMobileMenu) ? '0px' : '15px 10px' }"  v-bind:class="(rightMobileMenu) ? 'ui sidebar right visible' : 'three wide  computer tablet only column' ">

    <h5 class="ui header">Channels</h5>

    <div v-for="account in orderByName(onlyActiveAccounts)" :key="account._id" @click="updateAccounts(account);" class="checkboxInput">
      <div :class="(isActive(account._id, 'Channels')) ? 'checked' : '' " class="checkbox">
        <i class="icon-check check icon"></i>
      </div>
      <div style="position: relative;" class="checkboxLabel">
        <img style="margin-right: 4px; width: 22px; border-radius: 5px; vertical-align: middle;" :src="account.avatar"> 
          <img :src="func.getPlatformImage(account.platform)" style="bottom: -5.5px;width: 14px;height: 14px;border-radius: 20px;vertical-align: middle;position: absolute;left: -5.5px;border: 1px solid #fff;" alt="">
          <span style="display: inline-block;">{{account.name.substring(0,10)}}</span>
        </div>
    </div>

<h5 class="ui header filtering">Date Range</h5>

<div class="ui form">
  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">FROM :</span>
    <datetime style="position:relative;" :max-datetime="currentDate" v-model="startDate" input-id="startDate">
      <i style="position: absolute;right: 6px;top: 9px; color: #ddd; z-index:1;" for="startDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
                    <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    </datetime>
    <div style="height:10px;"></div>
  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">TO :</span>
    <datetime style="position:relative;" :min-datetime="startDate" :max-datetime="currentDate" v-model="endDate"  input-id="endDate">
      <i style="position: absolute;right: 6px;top: 9px; color: #ddd; z-index:1;" for="endDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
                    <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    </datetime>
  </div>  
</div>
</template>


<style scoped>
.vdatetime-popup__actions__button {
    padding: 0px 0px !important;
}
.vdatetime-input{
  border: 2px solid #e5e5e5 !important;
  border-radius: 0 5px 5px 5px !important;
}
.vdatetime-input:hover{
  cursor: pointer;
  background: #f1f1f1;
}
.radioButtonGroup {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    /* flex-direction: column; */
    -webkit-box-align: start;
    align-items: flex-start;
    flex-direction: column;
}

.radioButtonInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.radioButtonGroup .radioButtonInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonInput {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
}

.radioButtonGroup .radioButtonInput .radioButton.selected {
    border: 2px solid #3960BD;
}

.radioButtonGroup .radioButtonInput .radioButton {
    position: relative;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    cursor: pointer;
    border-radius: 18px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    }

    .radioButtonGroup .radioButtonInput .radioButtonLabel {
    cursor: pointer;
    padding: 0 10px;
    font-size: 14px;
    line-height: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radioButtonGroup .radioButtonInput .radioButton.selected .selectedDot {
    background: #3960BD;
    opacity: .8;
}

.radioButtonGroup .radioButtonInput .radioButton .selectedDot {
    width: 7px;
    height: 7px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #aaa;
    opacity: 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    transform: translate(-50%, -50%);
    border-radius: 7px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonGroup .radioButtonInput:hover .radioButton.selected .selectedDot {
    opacity: .8;
}

.radioButtonGroup .radioButtonInput:hover .radioButton .selectedDot {
    opacity: .3;
}

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
    margin: 0 10px;
    font-size: 14px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.filterItem {
  border: 1px solid #F3F3F3;
  padding: 5px 10px; 
  border-radius: 3px;
  cursor:pointer;
}
.filterItem:hover {
  background: #f9f9f9; 
  border: 1px solid #e9e9e9;
  border-radius: 3px;
}
.filterItem.active {
  background: #f9f9f9; 
  border: 1px solid #e9e9e9;
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/StatisticsFilter.vue